import {
  globalConstants,
  userConstants,
  spotConstants,
  globalSystemConstants,
} from "../../constants";

const {
  PUBLIC_SPOTS,
  SPOT_DATA_BY_ID,
  ADMIN_SPOTS_LIST,
  ALL_SPOTS,
  SPOT_DATA_BY_CENTER_ID,
  ALL_APPROVED_PUBLIC_PRIVATE_SPOTS,
  SPOT_DATA_BY_ID_NULL
} = spotConstants;

const initialState = {
  spotsData: null,
  openModal: false,
  spotDataById: [],
  openAppRejModal: false,
  publicSpots: [],
  allSpots: [],
  spotDataByCenterId: [],
  allApprovedPublicPrivateSpots: [],
};

const spotReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_SPOTS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        spotsData: action.data,
      };
    case userConstants.OPEN_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        openModal: action.data,
      };
    case userConstants.OPEN_APPREJ_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        openAppRejModal: action.data,
      };
    case SPOT_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        spotDataById: action.data,
      };
    case SPOT_DATA_BY_CENTER_ID + globalConstants.SUCCESS:
      return {
        ...state,
        spotDataByCenterId: action.data,
      };
    case PUBLIC_SPOTS + globalConstants.SUCCESS:
      return {
        ...state,
        publicSpots: action.data,
      };
    case ALL_SPOTS + globalConstants.SUCCESS:
      return {
        ...state,
        allSpots: action.data,
      };
    case ALL_APPROVED_PUBLIC_PRIVATE_SPOTS + globalConstants.SUCCESS:
      return {
        ...state,
        allApprovedPublicPrivateSpots: action.data,
      };
    case globalSystemConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case globalSystemConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    case SPOT_DATA_BY_ID_NULL + globalConstants.SUCCESS:
      return {
        ...state,
        spotDataById: [],
      };

    default:
      return state;
  }
};

export default spotReducer;
